import React, { useState, useEffect } from "react";
import moment from "moment";

import SamplesResults from "./SamplesResults";

export default function AliquotsResults({ aliquot_ids, start_date, clientView = true }) {
  const [loaded, setLoaded] = useState(false);
  const [searchParams] = useState({
    aliquot_ids,
    start_date: moment(start_date).format("YYYY-MM-DD"),
    end_date: moment(start_date).format("YYYY-MM-DD")
  });

  return (
    <div>
      {!loaded && (
        <p>
          <i className="fa fa-spinner fa-spin" />
          &nbsp;Loading...
        </p>
      )}

      <SamplesResults
        searchParams={searchParams}
        clientView={clientView}
        simpleSampleView={false}
        searchCallback={() => setLoaded(true)}
      />
    </div>
  );
}
